import { api } from '@/portal-api.definition';
import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';

export function useResendInvite() {
  const toast = useToast();
  const { t } = useI18n();
  return useNosIdMutation({
    mutationFn: (userId: string) =>
      api.post('/api/v1/users/secondary/:userId/resend-invite', undefined, {
        params: { userId },
      }),
    successLogAction: () => ({ ActionType: ActionType.Submit }),
    errorLogAction: () => ({ ActionType: ActionType.Submit }),
    onSuccess: () => {
      toast.show('success', t('Common.SnackBar.InviteResent'));
    },
  });
}
